import { render, staticRenderFns } from "./FilesForm.vue?vue&type=template&id=6714f734&scoped=true&"
import script from "./FilesForm.vue?vue&type=script&lang=js&"
export * from "./FilesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6714f734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6714f734')) {
      api.createRecord('6714f734', component.options)
    } else {
      api.reload('6714f734', component.options)
    }
    module.hot.accept("./FilesForm.vue?vue&type=template&id=6714f734&scoped=true&", function () {
      api.rerender('6714f734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-order/components/FilesForm.vue"
export default component.exports